import * as React from "react";
import { Button } from "tabler-react";

export default function RefreshButton({ onClick, loading }) {
  return (
    <Button
      icon="refresh-cw"
      color="secondary"
      outline
      size="sm"
      onClick={onClick}
      disabled={loading}
      title="Refresh"
    />
  );
}
